import styled from "styled-components";
import { colorWhite } from "@nib-components/theme";
export const Wrapper = styled.div`
	display: flex;
	justify-content: center:
	align-items: center;
	margin-right: 5px;
	color: ${colorWhite};
`;